import { MODAL_CLEAR_ALL, MODAL_CLOSE, MODAL_OPEN } from "./actions";

const initialState = [];

export function modalsReducer(state = initialState, action) {
	switch (action.type) {
		case MODAL_OPEN: {
			const key = action.data.key;
			return state.includes(key) ? state : [...state, ...[key]];
		}
		case MODAL_CLOSE: {
			const key = action.data.key;

			if (state.includes(key)) {
				const index = state.indexOf(key);
				let newModals = [...state];

				if (index > -1) {
					newModals.splice(index, 1);
				}

				return newModals;
			} else {
				return state;
			}
		}
		case MODAL_CLEAR_ALL:
			return initialState;
		default:
			return state;
	}
}
